export const ENTRY_SEGMENT = {
  SALE_LP: 'sale_lp',
  SAMPLER_LP: 'sampler_lp',
  TARGETED_PAGE: 'targeted_page',
};

const ENTRY_SEGMENT_VALUES = new Set(Object.values(ENTRY_SEGMENT));

/**
 * Drop query, hash, and trailing slashes so /sale?utm=… and /sale/ match /sale.
 * @param {string} pathname
 * @returns {string}
 */
export const normalizeEntryPath = pathname => {
  if (!pathname) return '/';

  const withoutHash = String(pathname).split('#')[0];
  const withoutQuery = withoutHash.split('?')[0];
  const withoutTrailingSlash = withoutQuery.replace(/\/+$/, '') || '/';

  return withoutTrailingSlash.toLowerCase();
};

export const mapEntrySegment = pathname => {
  const path = normalizeEntryPath(pathname);

  if (path === '/sale') return ENTRY_SEGMENT.SALE_LP;
  if (path === '/sampler') return ENTRY_SEGMENT.SAMPLER_LP;

  return ENTRY_SEGMENT.TARGETED_PAGE;
};

export const isEntrySegment = value => ENTRY_SEGMENT_VALUES.has(value);

export const ENTRY_SEGMENT_COOKIE = 'entry_segment';
// Chrome caps a cookie at 400 days. That outlasts an AB Tasty assignment
// (test duration + 2 weeks) and matches the visitor-cookie horizon.
export const ENTRY_SEGMENT_COOKIE_DAYS = 400;
export const ENTRY_SEGMENT_COOKIE_MAX_AGE_SECONDS =
  ENTRY_SEGMENT_COOKIE_DAYS * 24 * 60 * 60;

// Present on the request only when this browser has visited before.
// ABTastySession is a different cookie and must not count.
export const PRIOR_VISIT_COOKIE_NAMES = ['ABTasty', 'ajs_anonymous_id'];

export const hasPriorVisitCookie = hasCookie =>
  PRIOR_VISIT_COOKIE_NAMES.some(name => Boolean(hasCookie(name)));

/**
 * Null on a first visit, and null when a segment is already stored.
 */
export const priorEntrySegmentToSet = ({ storedValue, hasCookie }) => {
  if (isEntrySegment(storedValue)) return null;
  if (hasPriorVisitCookie(hasCookie)) return ENTRY_SEGMENT.TARGETED_PAGE;

  return null;
};
